/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedPersonalizedFilterToast_shippingFilters$ref: FragmentReference;
export type SbSharedPersonalizedFilterToast_shippingFilters = $ReadOnlyArray<{|
  +totalCount: ?number,
  +$refType: SbSharedPersonalizedFilterToast_shippingFilters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedPersonalizedFilterToast_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '62ccccb1a602b84a1bef0784594396d5';
module.exports = node;
